var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['flex', 'items-center', 'text-12-16', 'overflow-hidden']},[_c(_setup.isRegistered ? 'a' : 'span',{directives:[{name:"emit-click-on-touch",rawName:"v-emit-click-on-touch"}],tag:"component",class:['flex items-center min-w-0', _setup.isRegistered ? 'cursor-pointer' : 'cursor-default'],attrs:{"href":_setup.authorProfileUrl,"target":"_blank","data-bridged-link":"profile","data-bridged-link-username":_setup.author.username,"aria-label":_setup.isRegistered ? _vm.__('Go to %{profileName} profile', { profileName: _setup.authorName }) : undefined,"title":_setup.isRegistered ? _vm.__('Go to %{profileName} profile', { profileName: _setup.authorName }) : undefined},on:{"click":(event) => !_setup.device.app && event.stopPropagation()}},[_c(_setup.AvatarImage,{attrs:{"user":_setup.isRegistered ? _setup.author : {},"width":_vm.avatarSize,"height":_vm.avatarSize}}),_c('span',{class:[
        'text-12-16',
        'ms-2',
        {
          'text-light-text-100': _setup.colorScheme === 'dark',
          'text-dark-text-100': _setup.colorScheme === 'light',
        },
        'font-semibold',
        'truncate',
      ]},[_vm._v(_vm._s(_setup.authorName))])],1),_vm._v(" "),(_setup.publishedAt)?_c(_setup.OzRelativeTime,{class:[
      'ms-1',
      'font-normal',
      'text-12-16',
      {
        'text-light-text-300': _setup.colorScheme === 'dark',
        'text-dark-text-300': _setup.colorScheme === 'light',
      },
      'shrink-0',
      'cursor-default',
    ],attrs:{"datetime":_setup.publishedAt,"data-autorefresh":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }